import { CoreListEnvelop } from '@mkp/shared/models';
import { BaseHttpResource } from '@mkp/shared/data-access';
import {
  LegalEntity,
  LegalEntityCheUidPostBody,
  LegalEntityDto,
  LegalEntityPatchBody,
  LegalEntityPostBody,
  LegalEntitySettings,
} from '@mkp/legal-entity/models';
import { map, Observable } from 'rxjs';
import { mapLegalEntityDtoToLegalEntity } from './legal-entity.mapper';
import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class LegalEntityResource extends BaseHttpResource<
  LegalEntityDto,
  CoreListEnvelop<LegalEntityDto>,
  LegalEntityPostBody,
  LegalEntityPatchBody
> {
  constructor() {
    super('legal-entity');
  }

  patchState({
    id,
    state,
    _version,
  }: {
    id: LegalEntity['id'];
    state: LegalEntity['state'];
    _version: LegalEntity['_version'];
  }): Observable<LegalEntity> {
    return this.update(id, { state, _version }).pipe(
      map((legalEntityDto) => mapLegalEntityDtoToLegalEntity(legalEntityDto))
    );
  }

  patchSettings({
    id,
    settings,
    _version,
  }: {
    id: LegalEntity['id'];
    settings: LegalEntitySettings;
    _version: LegalEntity['_version'];
  }): Observable<LegalEntity> {
    return this.update(id, { settings, _version }).pipe(
      map((legalEntityDto) => mapLegalEntityDtoToLegalEntity(legalEntityDto))
    );
  }

  checkIsClaimed(legalEntity: Pick<LegalEntity, 'externalId'>): Observable<null> {
    const headers = new HttpHeaders({
      maxRetry: 1,
    });
    return this.http.post<null>(
      `${this.url}/check-is-claimed`,
      {
        cheUid: legalEntity.externalId,
      },
      { headers }
    );
  }

  createByCheUid(claimCompanyDto: LegalEntityCheUidPostBody): Observable<LegalEntityDto> {
    return this.http.post<LegalEntityDto>(`${this.url}/create-by-cheuid`, claimCompanyDto);
  }

  fetchLegalEntitiesByIds(ids: string[]): Observable<LegalEntityDto[]> {
    const filter = ids.map((id) => `id==${id}`).join(',');

    return this.getWithQuery({ filter }).pipe(map((response) => response._embedded.results));
  }
}
